import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";

import { Config } from "src/app/config";
import { UserAuthService } from "src/app/services/userauth.service";
import { ExamService } from "src/app/services/exam.service";
import { ModalDialogService } from "src/app/modals/modaldialog/modaldialog.service";
import { User } from "src/app/models/user";

@Component({
  selector: "hkt-pageexam",
  templateUrl: "./pageexam.component.html",
  styleUrls: ["./pageexam.component.scss"],
})
export class PageExamComponent implements OnInit, OnDestroy {
  user: User;
  websiteName: string;
  routerParams: Subscription;
  examId: number;

  constructor(
    private router: Router,
    private userAuthService: UserAuthService,
    private examService: ExamService,
    private activatedRoute: ActivatedRoute,
    private modalDialogService: ModalDialogService,
  ) {}

  ngOnInit() {
    this.user = this.userAuthService.currentUser;
    this.websiteName = "";

    this.routerParams = this.activatedRoute.params.subscribe(params => {
      this.examId = +params["id"];
      this.examService.loadUserExam(this.examId, this.user.id).subscribe(
        response => {
          if (response == false) {
            this.modalDialogService.showAlert(Config.APP_NAME, "Error loading the exam, try to login again", () => {
              this.userAuthService.logout();
              this.router.navigate(["login", this.examId]);
            });
            return;
          }
          this.websiteName = this.examService.currentExam.name;
        },
        error => {
          console.error("Error: " + error);
        },
      );
    });
  }

  ngOnDestroy() {
    this.routerParams.unsubscribe();
  }

  onLogout(): boolean {
    this.userAuthService.logout();
    this.router.navigate(["login", this.examId]);
    return false;
  }

  toggleMenu(): void {}
}
